export const baseUrl = "http://www.maisuiedu.com/api";
// export const baseUrl = "http://10.10.30.11:9002/api";
// export const baseUrl = "http://192.168.10.21:9024";

// export const baseUrl = "http://192.168.10.78:9024";
